module.exports = __webpack_public_path__ + "71dfaafd0834f367993d0dc23075fd9d.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/alert.svg
// module id = 2479
// module chunks = 15